// Others
import axiosClient from './axiosClient';
import { urlApiInventory } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  ICloneProduct,
  IInventoryDetail,
  IInventoryHistory,
  IInventoryProduct,
  IInventoryQuote,
  IParamDetailInventory,
  IParamInventoryHistory,
  IParamInventoryProduct,
  IParamInventoryQuote,
} from '~/utils/interface/inventory';
import { IProductAvailability } from '~/utils/interface/jobs';
import { IExportDataReport } from '~/utils/interface/reports';

const inventoryApi = {
  getListInventoryQuote: (params: IParamInventoryQuote) => {
    const url = urlApiInventory.getListInventoryQuote;
    return axiosClient.get<IBaseResponse<IListDataResponse<IInventoryQuote[]>>>(url, { params });
  },

  getListInventoryProduct: (params: IParamInventoryProduct) => {
    const url = urlApiInventory.getListInventoryProduct;
    return axiosClient.get<IBaseResponse<IListDataResponse<IInventoryProduct[]>>>(url, { params });
  },

  getListInventoryHistory: (params: IParamInventoryHistory) => {
    const { inventoryId, query } = params;

    const url = urlApiInventory.getListInventoryHistory(inventoryId);
    return axiosClient.get<IBaseResponse<IListDataResponse<IInventoryHistory[]>>>(url, { params: query });
  },

  getDetailInventory: (params: IParamDetailInventory) => {
    const { inventoryId, type, query } = params;
    const url = urlApiInventory.getDetailInventory(inventoryId, type);
    return axiosClient.get<IBaseResponse<IInventoryDetail | IProductAvailability[]>>(url, { params: query });
  },

  createInventory: (formData: FormData) => {
    const url = urlApiInventory.createInventory;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  importInventory: (formData: FormData) => {
    const url = urlApiInventory.importInventory;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteInventory: (id: string) => {
    const url = urlApiInventory.deleteInventory(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  updateInventory: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiInventory.updateInventory(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  exportInventory: (params: IParamInventoryProduct) => {
    const url = urlApiInventory.exportInventory;

    return axiosClient.get<IBaseResponse<IExportDataReport>>(url, { params });
  },

  cloneInventory: (body: ICloneProduct) => {
    const url = urlApiInventory.cloneInventory;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default inventoryApi;
